(function($) {
	'use strict';

	/**
	 * Fetch and filter quality data for CRF frameworks
	 * 
	 * This function fetches quality data from the WordPress AJAX endpoint and validates
	 * the data structure for the specified year. It's designed to work across different
	 * CRF years (2021, 2022, 2023, 2024, 2025, etc.) by accepting a year parameter.
	 * 
	 * @param {string} year - The CRF year to fetch data for (e.g., "2025", "2024", "2023")
	 * @returns {Promise<Object>} Promise that resolves with the quality data or rejects with an error
	 */
	function fetchQualityData(year = "2025") {
		console.log('fetchQualityData called within fetchQualityData.js with year:', year);
		return new Promise((resolve, reject) => {
			$.ajax({
				url: '/wp-admin/admin-ajax.php',
				method: 'POST',
				data: {
					action: 'get_quality_data_by_year',
					year: year
				},
				dataType: 'json',
				success: function (data) {
					if (data.CRF && data.CRF.Items && data.Combined) {
						resolve(data);
					} else {
						reject(`Data is missing expected structure for year ${year}`);
					}
				},
				error: function (xhr, status, error) {
					reject('Error fetching data: ' + error);
				}
			});
		});
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { fetchQualityData };
	} else if (typeof window !== 'undefined') {
		window.fetchQualityData = fetchQualityData;
	}

})(jQuery);
